(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home_cinema_category_section"] && !Shopify.designMode) return;
  try {
    
// <<<<<<<<home_cinema_category_slider_start>>>>>>>>
document.addEventListener('DOMContentLoaded', function () {
            var swiper = new Swiper('.swiper-container', {
                loop: true,
                slidesPerView: 2, 
                spaceBetween: 5, 
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
               
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    600: {
                        slidesPerView: 3,
                    },
                    1000: {
                        slidesPerView: 5,
                    },
                },
                
            });
        });
// <<<<<<<<home_cinema_category_slider_end>>>>>>>>

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home_cinema_setup_mobile"] && !Shopify.designMode) return;
  try {
    
function showTab(mainIndex, dotIndex = null) {
    const faqs = document.querySelectorAll('.home_cinema_new_for_mobile .home_cinema_mobile-faq');

    // Hide all
    faqs.forEach(faq => faq.classList.remove('active'));

    // Show selected FAQ
    if (mainIndex >= 0 && mainIndex < faqs.length) {
        faqs[mainIndex].classList.add('active');
    }

    // Reset all dots
    document.querySelectorAll('.home_cinema_mobile-dot').forEach(dot => {
        dot.classList.remove('active');
    });

    // Add active to the relevant dots
    if (dotIndex === null) {
        // No dotIndex passed — set the matching dot for the active FAQ
        const activeFaqDots = faqs[mainIndex].querySelectorAll('.home_cinema_mobile-dot');
        activeFaqDots[mainIndex]?.classList?.add('active');
    } else {
        // Activate the specific dot
        const dots = faqs[mainIndex].querySelectorAll('.home_cinema_mobile-dot');
        if (dotIndex >= 0 && dotIndex < dots.length) {
            dots[dotIndex].classList.add('active');
        }
    }
}

// Accordion toggle on question click
document.addEventListener('DOMContentLoaded', function () {
    const questions = document.querySelectorAll('.home_cinema_mobile-question');

    questions.forEach((question, index) => {
        question.addEventListener('click', () => {
            const faqs = document.querySelectorAll('.home_cinema_new_for_mobile .home_cinema_mobile-faq');

            // If already active, close it
            if (faqs[index].classList.contains('active')) {
                faqs[index].classList.remove('active');
            } else {
                // Close all others
                faqs.forEach(faq => faq.classList.remove('active'));
                // Open clicked one
                faqs[index].classList.add('active');
            }
        });
    });

    // Default open first
    showTab(0);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tivoli-services-tabs"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener("DOMContentLoaded", function () {
    const tabLinks = document.querySelectorAll('.product__nav a');
    const tabPanes = document.querySelectorAll('.tab__container .tab-pane');

    tabLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        // Remove 'active' class from all tabs
        tabLinks.forEach(item => item.classList.remove('active'));
        // Hide all tab panes
        tabPanes.forEach(pane => pane.classList.remove('active'));

        // Activate clicked tab
        this.classList.add('active');

        // Activate corresponding tab pane
        const targetId = this.getAttribute('href').replace('#', '');
        const targetPane = document.getElementById(targetId);
        if (targetPane) {
          targetPane.classList.add('active');
        }
      });
    });
  });



  } catch(e) { console.error(e); }
})();
})();
